import React from 'react';
import s from './JobIcon.module.scss';

const EmployeeIcon = () => {
  return (
    <svg className={s.employeeIcon} width="80" height="64" viewBox="0 0 80 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M62.3354 64C52.6539 64 43.8217 56.6613 43.8217 41.984C43.8217 23.7227 56.3907 11.9467 69.8089 0L78.3015 10.752C64.8832 18.0907 58.0892 24.2347 55.0318 31.744C56.9002 29.8667 59.7877 28.8427 63.3546 28.8427C72.1868 28.8427 80 36.1813 80 46.08C80 56.32 72.5265 64 62.3354 64ZM0 41.984C0 23.7227 12.569 11.9467 25.9873 0L34.4798 10.752C21.0616 18.0907 14.2675 24.2347 11.2102 31.744C13.0786 29.8667 15.966 28.8427 19.5329 28.8427C28.3652 28.8427 36.1783 36.1813 36.1783 46.08C36.1783 56.32 28.7049 64 18.5138 64C8.83227 64 0 56.6613 0 41.984Z" fill="#41B64D"/>
    </svg>
  )
}

export default EmployeeIcon;